<script>
    import { navigate, querystring } from "../router";
    import { extractParams } from "../utils.js";
    import { getUser } from "../user.js";
    import { HStack, VStack, Spacer, MediaQuery } from "../component/layout";
    import { Padding } from "../component/modifier";
    import { fromSQLDate } from "../date.js";
    import moment from "moment";
    import {
        Button,
        Label,
        Digit,
        TextView,
        Icon,
        Odometer,
        Tab,
        TabList,
        TabPanel,
    } from "../component/widget";
    import { showOK, showError } from "../dialog.js";
    import {
        push,
        teamName,
        action,
        load as loadGame,
        join,
        results as resultsGame,
    } from "../quizz.js";
    import { loadGameForCode } from "../games.js";
    import { onMount, onDestroy } from "svelte";
    import { focusNext } from "../component/Form.svelte";
    import Chart from "svelte-frappe-charts";

    import { uniqueNamesGenerator, animals } from "unique-names-generator"

    let animaux = ["Acouchi",
"Addax",
"Agneau",
"Agouti",
"Aigle",
"Alligator",
"Allocèbe",
"Alouate",
"Alpaga",
"Âne",
"Angwantibo",
"Anoa",
"Anomalure",
"Antilope",
"Apelle",
"Ara",
"Atèle",
"Athérure",
"Aulacode",
"Autruche",
"Avahi",
"Aye aye",
"Babakoto",
"Babouin",
"Baleine",
"Bandar",
"Basilic vert",
"Belette",
"Béluga",
"Biche",
"Bison",
"Blaireau",
"Boeuf",
"Bongo",
"Bonobo",
"Bouquetin",
"Brebis",
"Bubale roux",
"Buffle",
"Cabiaï",
"Cacatoès",
"Cachalot",
"Caïman noir",
"Campagnol",
"Caouanne",
"Capucin",
"Capybara",
"Caracal",
"Carcajou",
"Cariacou",
"Caribou",
"Castor",
"Casoar à casque",
"Cercocèbe",
"Cercopithèque",
"Cerf",
"Chacal",
"Chacma",
"Chameau",
"Chamois",
"Chat",
"Chaus",
"Chauve-souris",
"Cheval",
"Chèvre",
"Chevreuil",
"Chien",
"Chien de prairie",
"Chimpanzé",
"Chinchilla",
"Chirogale",
"Chouette effraie",
"Chouette hulotte",
"Chozchoz",
"Civette",
"Coati",
"Cobaye",
"Cobe à croissant",
"Cobra Royal",
"Cochon",
"Cochon d’Inde",
"Colobe",
"Colocolo",
"Condor des Andes",
"Coruro",
"Couguar",
"Couleuvre",
"Couscous",
"Coyote",
"Crapaud",
"Crocodile",
"Cryptoprocte féroce",
"Cuon d’Asie",
"Cynocéphale",
"Daman",
"Daim",
"Dauphin",
"Dègue",
"Dhole",
"Diable de Tasmanie",
"Dingo",
"Douc",
"Douroucouli",
"Drago",
"Dragon de Komodo",
"Drill",
"Dromadaire",
"Dugong",
"Échidné",
"Écureuil",
"Écureuil antilope",
"Écureuil roux",
"Écureuil volant",
"Élan",
"Éland",
"Éléphant",
"Émeu",
"Entelle",
"Épaulard",
"Eyra",
"Faon",
"Faucon pèlerin",
"Fennec",
"Flamant rose",
"Fossa",
"Fouine",
"Fourmilier",
"Furet",
"Galogo",
"Gaufre",
"Gaur",
"Gayal",
"Gavial du Gange",
"Gazelle",
"Gecko",
"Gélada",
"Genette",
"Géocoucou de Californie",
"Gerbille",
"Gerboise",
"Gibbon",
"Girafe",
"Glouton",
"Gnou",
"Goret",
"Gorille",
"Goundi",
"Grand duc d’Europe",
"Grand requin blanc",
"Griffon",
"Grizzly",
"Grue royale",
"Guanaco",
"Guépard",
"Guéréza",
"Guigna",
"Gypaète barbu",
"Hamadryas",
"Hamster",
"Harfang des neiges",
"Harpie féroce",
"Hérisson",
"Hermine",
"Hibou",
"Hippopotame",
"Hirondelle",
"Hocheur",
"Houlock",
"Hurleur noir",
"Hutia",
"Hydrochère",
"Hyène",
"Iguane",
"Impala",
"Indri",
"Isard",
"Isatis",
"Jaguar",
"Jaguarondi",
"Jubarte",
"Jutia",
"Kangourou",
"Koala",
"Kodkod",
"Kookaburra",
"Koudou",
"Lagotriche",
"Lama",
"Lamantin",
"Langur",
"Lapin",
"Lemming",
"Lémur catta",
"Lémurien",
"Léopard",
"Léopard des neiges",
"Lépilémur",
"Lérot",
"Lérotin",
"Lézard",
"Lièvre",
"Lion",
"Loir",
"Loris",
"Loup",
"Loutre",
"Lycaons",
"Lynx",
"Macareux moine",
"Macaque",
"Magot",
"Maki catta",
"Mammouth",
"Manchot empereur",
"Mandrill",
"Mangabey",
"Mangouste",
"Manul",
"Mara",
"Marabout",
"Marmotte",
"Marmousset",
"Marsouin",
"Martin-pêcheur",
"Martre",
"Mégaptère",
"Messager sagittaire",
"Microcèbe",
"Miopithèque",
"Moloch hérissé",
"Monstre de Gila",
"Morse",
"Moufette",
"Mouflon",
"Moustac",
"Mouton",
"Mule",
"Mulot",
"Musaraigne",
"Muscardin",
"Narval",
"Nasique",
"Noctule",
"Numbat",
"Nyala",
"Ocelot",
"Octodon",
"Okapi",
"Once",
"Ondatra",
"Opossum",
"Orang-outan",
"Oréotrague",
"Orignal",
"Ornithorynque",
"Orque",
"Orvet",
"Oryctérope",
"Oryx",
"Otarie",
"Ouakari",
"Ouandérou",
"Ouistiti",
"Ouistiti argenté",
"Ouistiti pygmée",
"Ours brun",
"Ours polaire",
"Paca",
"Pacarana",
"Panda",
"Panda roux",
"Pangolin",
"Panthère",
"Panthère nébuleuse",
"Paresseux",
"Patas",
"Pécaris",
"Pékan",
"Pélican",
"Perentie",
"Perroquet",
"Pétauriste",
"Phacochère",
"Phalanger volant",
"Phaner",
"Phoque",
"Phyllobate terrible",
"Pika",
"Pinché",
"Pipistrelle",
"Polatouche",
"Poney",
"Porc",
"Porc-épic",
"Pottos",
"Puma",
"Putois",
"Pronghorn",
"Propithèque de Coquerel",
"Pygargue à tête blanche",
"Python",
"Quokka",
"Ragondin",
"Rainette verte",
"Rat",
"Rat palmiste",
"Rat-taupe",
"Raton laveur",
"Ratufa indica",
"Renard",
"Renne",
"Requin",
"Requin baleine",
"Requin marteau",
"Requin-scie",
"Rhésus",
"Rhinocéros",
"Rhinopithèque",
"Rorqual à bosse",
"Sagouin",
"Saïga",
"Saïmiri",
"Salamandre",
"Sajou",
"Saki",
"Sambar",
"Sanglier",
"Sapajou",
"Sassa",
"Secrétaire",
"Serpentaire",
"Serval",
"Siamang",
"Siciste",
"Sifaka",
"Silène",
"Singe",
"Singe araignée",
"Singe écureuil",
"Singe hurleur",
"Singe laineux",
"Singe vert",
"Souffleur",
"Souris",
"Souris pygmée",
"Souslik",
"Spermophile",
"Sphynx",
"Springbok",
"Sterne arctique",
"Suricate",
"Taïpan du désert",
"Talapoin",
"Tamandua",
"Tamanoir",
"Tamarin",
"Tamia",
"Tapir",
"Tarsier",
"Tatou",
"Taureau",
"Tarente commune",
"Tigre",
"Tigre Blanc",
"Titi roux",
"Tortue",
"Toucan",
"Triton alpestre",
"Tuco-tuco",
"Tursiops",
"Unau",
"Uraète",
"Urial",
"Vache",
"Varan de Komodo",
"Vari roux",
"Vautour",
"Veau",
"Verrat",
"Vervet",
"Vigogne",
"Viscache",
"Vison",
"Wallaby",
"Wapiti",
"Watussi",
"Wombat",
"Xérus",
"Yack",
"Zapode",
"Zèbre",
"Zébrule",
"Zébu",
"Zibeline",
"Zokor",
"Zorille",
"Zyzomys"]
    /*

    const { uniqueNamesGenerator, adjectives, colors, animals } = require('unique-names-generator');

const randomName = uniqueNamesGenerator({ dictionaries: [adjectives, colors, animals] }); // big_red_donkey

const shortName = uniqueNamesGenerator({
  dictionaries: [adjectives, animals, colors], // colors can be omitted here as not used
  length: 2
}); // big-donkey

    */

    export let wedding_guid;

    let code;
    let team;
    let game_id;
    let game;
    let games;
    let joined_count = 0;
    let is_admin = false;
    let is_details = false;
    let mode;
    let admin_code;
    let game_type;
    let item;
    let current_idx;
    let result;
    let result_global = [];
    let selectedTab;

    let user_id;
    let disabled = false;
    let choiceA = false;
    let choiceB = false;
    let choiceC = false;
    let choiceD = false;

    let form = undefined;

    let c1 = null;
    let c2 = null;
    let c3 = null;
    let c4 = null;
    let c5 = null;
    let c6 = null;
    let current = "";

    let userRequest = getUser();
    let user = $userRequest;
    
    async function waitUser() {

        try {
            let r = await user;
        } catch (e) {
            // annymous is ok
        }
    }

    $: game_type = game?.type;

    let team_name;
    let wedding_name;

    let now = new Date();

    //moment.defineLocale("fr", localeData(moment));
    moment.locale("fr");

    async function getTeamName(team) {
        if (code && !team) {
            try {
                await waitUser();
                let r = await teamName(code, team);
                team_name = r.name;
                wedding_name = r.wedding_name;
                console.log(r);
            } catch (e) {
                console.log(e);
                team_name = uniqueNamesGenerator({ dictionaries: [animaux], length: 1});
                wedding_name = "";
            }
        }
    }

    $: getTeamName(code, team);

    $: {
        is_admin = extractParams("admin", $querystring, true);
        is_details = extractParams("details", $querystring, true);
        game_id = extractParams("game", $querystring);
        team = extractParams("team", $querystring);
        if (team === null) {
            team = "none";
        }
        if (is_admin) {
            admin_code = extractParams("admin_code", $querystring);
        } else {
            code = extractParams("code", $querystring);
        }
    }

    $: load(mode, item, game);
    $: getMode(is_admin, is_admin ? admin_code : code, game_id);

    //$: console.log(code, team, user_id, game_id);
    //$: console.log("item", item);
    //$: console.log("result", result);

    let chartRef;
    let data = {
        labels: ["A", "B", "C", "D"],
        datasets: [
            {
                values: [0, 0, 0, 0],
            },
        ],
    };
    let totalReponse;

    function refreshResult(r) {
        //console.log(r);
        let values = [0, 0, 0, 0];
        if (r) {
            let A = parseInt(r.A, 10);
            if (isNaN(A)) A = 0;
            let B = parseInt(r.B, 10);
            if (isNaN(B)) B = 0;
            let C = parseInt(r.C, 10);
            if (isNaN(C)) C = 0;
            let D = parseInt(r.D, 10);
            if (isNaN(D)) D = 0;

            const total = A + B + C + D;
            totalReponse = total;
            //console.log(A, B, C, D, total);
            if (total > 0) {
                values = [
                    (A / total) * 100,
                    (B / total) * 100,
                    (C / total) * 100,
                    (D / total) * 100,
                ];
            }
        }
        //console.log(values);
        data = {
            labels: ["A", "B", "C", "D"],
            yMarkers: [{ label: "", value: 100 }],
            datasets: [
                {
                    values: values,
                },
            ],
        };
    }

    let odo1;
    let odo2;
    let odo3;
    let odo4;

    $: odoCode = `${odo1}${odo2}${odo3}${odo4}`;

    const tryUnlock = async () => {
        console.log("try unlock with code", odoCode);

        if (disabled) return;

        disabled = true;
        try {
            let res = await push(code, game_id, user_id, team_name, odoCode);
            console.log(res);
            if (res.r === "1") {
                await showOK("Code correct !");
                // reload new item
                item = null;
            } else {
                // restart timer with new ttl
                startTimer(item, res.item_ttl > 0 ? "OPENED" : "CLOSED", res.item_ttl);
                await showError(
                    "Mauvais code... Pénalité de " +
                        moment.duration(res.penalty, "seconds").humanize()
                );
            }
            disabled = false;
        } catch (e) {
            console.log(e);

            if (e.message == "422 - 365 User not joined.") {
                // try to join
                try {
                    let res2 = await join(code, game_id, team_name, user_id);
                    console.log(res2);
                    user_id = res2.user;
                    game = res2.data;
                    mode = "client";

                    // then retry
                    res2 = await push(code, game_id, user_id, team_name, odoCode);
                    if (res2.r === "1") {
                        await showOK("Code correct !");
                    } else {
                        startTimer(item, res.item_ttl > 0 ? "OPENED" : "CLOSED", res.item_ttl);
                        await showError(
                            "Mauvais code... Pénalité de " +
                                moment.duration(res.penalty, "seconds").humanize()
                        );
                    }
                    disabled = false;
                } catch (ex) {
                    await showError(translateError(ex));
                    disabled = false;
                }
            } else {
                await showError(translateError(e));
                disabled = false;
            }
        }
    };

    function computeRank(ranks, total) {
        return ranks.slice(0, total).reduce((a, c) => a + c);
    }

    function extractRank(ranks) {
        return ranks.split(",").map((x) => parseInt(x, 10));
    }

    async function loadRanking(item) {
        if (item && (item.type === "R" || item.type === "F")) {
            try {
                //console.log("fetching ranking");
                let r = await resultsGame(admin_code, game_id, undefined, undefined);
                console.log(r);
                result = [];

                let minTotal = {};

                for (var d in r.data) {
                    let k = d.split("_");
                    let g = k[0];
                    let i = k[1];
                    let o = k[3];
                    let t = k[4];
                    let res = r.data[d];

                    if (t === "0" || t === undefined) {
                        continue;
                    }

                    if (!minTotal[i]) {
                        minTotal[i] = Number.MAX_SAFE_INTEGER;
                    }

                    let total = 0;
                    for (var c in res) {
                        if (c !== "rank") {
                            total += parseInt(res[c], 10);
                        }
                    }

                    if (total == 0) {
                        total = 1;
                    } else {
                        if (total < minTotal[i]) {
                            minTotal[i] = total;
                        }
                    }

                    // get correct response
                    let response = r.response[i];

                    let result_item = result.find((r) => r.item == i);
                    if (!result_item) {
                        result_item = {
                            item: parseInt(i, 10),
                            order: parseInt(o, 10),
                            result: [],
                        };
                        result.push(result_item);
                    }
                    result_item.result.push({
                        team: t,
                        count: parseInt(res[response] || "0", 10),
                        total: total,
                        pct: Math.floor((parseInt(res[response] || "0", 10) / total) * 100),
                        ranks: extractRank(res["rank"] || "99"),
                    });
                }

                result = result.sort((r1, r2) => r1.order - r2.order);

                let global = [];

                // Sorting teams
                result.forEach((r) => {
                    let total = minTotal[r.item];

                    r.result.forEach((res) => {
                        res.minTotal = total;
                        res.minCount = Math.min(total, res.count);
                        res.pctMin = Math.floor((Math.min(total, res.count) / total) * 100);
                        res.rank = computeRank(res.ranks, total);
                    });

                    r.result = r.result.sort((t1, t2) => {
                        if (t1.pctMin == t2.pctMin) {
                            if (t1.rank == t2.rank) {
                                if (t1.ranks[0] == t2.ranks[0]) {
                                    // ranks 0 => ordre alphabetique
                                    return t1.team.localeCompare(t2.team);
                                } else {
                                    return t1.ranks[0] - t2.ranks[0];
                                }
                            } else {
                                return t1.rank - t2.rank;
                            }
                        } else {
                            return t2.pctMin - t1.pctMin;
                        }
                    });

                    let len = r.result.length;
                    r.result.forEach((r) => {
                        if (r.pctMin > 0) {
                            r.score = len;
                        } else {
                            r.score = 0;
                        }

                        let team_res = global.find((e) => e.team === r.team);
                        if (!team_res) {
                            team_res = {
                                team: r.team,
                                score: 0,
                                rank: 0,
                            };
                            global.push(team_res);
                        }

                        team_res.score += r.score;
                        team_res.rank += r.rank;
                        len -= 1;
                    });
                });

                result_global = global.sort((t1, t2) => {
                    if (t1.score == t2.score) {
                        return t1.rank - t2.rank;
                    } else {
                        return t2.score - t1.score;
                    }
                });

                if (item.type === "R") {
                    selectedTab = result.length - 1;
                } else if (item.type === "F") {
                    selectedTab = "global";
                }

                console.log(result);
            } catch (e) {
                console.log(e);
            }
        }
    }

    $: refreshResult(result);

    $: loadRanking(item);

    //console.log(window.location);

    let wsBase;
    if (window.location.hostname == "localhost") {
        wsBase = "ws://localhost:26114/";
    } else {
        wsBase =
            (window.location.protocol == "http:" ? "ws:" : "wss:") +
            "//" +
            window.location.hostname +
            "/ws/";
    }

    //let wsBase = window.location.protocol + "//" + window.location.hostname + "/ws/";
    let ws;

    async function load(mode) {
        //console.log("load", mode, item);
        //
        if (mode && game && !item) {
            if (mode === "admin") {
                console.log("loading current item admin mode", admin_code, game_id);
                try {
                    let r = await loadGame(admin_code, game_id, true, true);
                    console.log(r);
                    item = r.item;
                    current_idx = r.current_idx;
                    //game = r.game;
                    

                    if (r.item_status === "OPENED") {
                        startItem(item, r.item_status, r.item_ttl);
                    } else if (r.data) {
                        let d = JSON.parse(r.data);
                        result = Array.isArray(d) ? null : d;
                    }

                    startItemTimer();

                } catch (e) {
                    console.log(e);
                    await showError(translateError(e));
                    mode = null;
                    game = null;
                }
            } else if (mode === "client" || mode === "master") {
                console.log("loading current item mode", mode, code, game_id);
                try {
                    let r = await loadGame(code, game_id, true, true, team_name);
                    console.log(r);
                    item = r.item;
                    current_idx = r.current_idx;
                    if (r.item_status === "OPENED") {
                        startTimer(item, r.item_status, r.item_ttl);
                    }
                } catch (e) {
                    console.log(e);
                    await showError(translateError(e));
                    // if (team) {
                    //     navigate(`#/champiz/${wedding_guid}?game=${game_id}&team=${team}`);
                    // } else {
                    //     navigate(`#/champiz/${wedding_guid}?game=${game_id}`);
                    // }
                }
            } 
        }
    }

    async function changeName() {

        localStorage.removeItem('champiz/team_name');
        localStorage.removeItem('champiz/user_id');

        joinGame(code, game_id);
    }

    async function joinGame(c, game_id) {

        let old_team = team_name;
        let old_id = user_id;

        // fetch team_name in local storage
        team_name = localStorage.getItem('champiz/team_name');
        user_id = localStorage.getItem('champiz/user_id');
        
        console.log("joining game client mode", c, game_id, team_name, user_id, old_team, old_id);

        let done = false;
        while (!done) {

            if (!team_name) {
                team_name = uniqueNamesGenerator({ dictionaries: [animaux], length: 1});  
            }

            try {

                let r = await join(c, game_id, team_name, user_id, old_team, old_id);
                console.log(r);
                user_id = r.user;
                game = r.data;
                mode = "client";
                if (r.admin) {
                    mode = "master";
                }
                done = true;
                localStorage.setItem('champiz/team_name', team_name);
                if (user_id !== undefined) {
                    localStorage.setItem('champiz/user_id', user_id);
                } else {
                    console.log("user_id undefined!");
                }
                
            } catch(e) {
                console.log(e);
                if (e.message == "422 - 163 Already exists." || e.message == "422 - 144 Already exists.") {
                    // retry 
                    localStorage.removeItem('champiz/team_name');
                    localStorage.removeItem('champiz/user_id');
                    team_name = undefined;
                    user_id = undefined;

                    await new Promise(r => setTimeout(r, 500));

                } else {
                    await showError(translateError(e));
                    done = true;
                }
            }

        }

    
    }

    async function getMode(is_adm, c, game_id) {
        if (!mode) {

            console.log("getMode", is_adm, c, game_id);

            await waitUser();

            if (is_adm && c) {
                console.log("starting current game item admin mode", c, game_id);
                try {
                    let r = await loadGame(c, game_id, true, true);
                    console.log(r);
                    mode = "admin";
                    item = r.item;
                    game = r.game;

                    //startGlobalWS();

                    if (r.item_status === "OPENED") {
                        startItem(item, r.item_status, r.item_ttl);
                    } else if (r.data) {
                        let d = JSON.parse(r.data);
                        result = Array.isArray(d) ? null : d;
                    }

                    startItemTimer();

                } catch (e) {
                    console.log(e);
                    try {
                        // start game
                        let r = await action(c, game_id, "start");
                        console.log(r);
                        mode = "admin";
                        game = r.data;
                    } catch (e) {
                        // wrong code ?
                        console.log(e);
                        await showError(translateError(e));
                        // if (game_id) {
                        //     navigate(`#/champiz/${wedding_guid}?admin&game=${game_id}`);
                        // } else {
                        //     navigate(`#/champiz/${wedding_guid}?admin`);
                        // }
                    }
                }
            } else if (c) {
                try {
                    if (team && !team_name) {
                        try {
                            let r = await teamName(code, team);
                            team_name = r.data.name;
                            wedding_name = r.data.wedding_name;
                            console.log("client mode", c, game_id, team_name);
                        } catch (e) {
                            console.log("no team => mode solo");
                        }
                    }

                    if (game_id) {
                        joinGame(c, game_id);
                    } else {
                        console.log("get all games for client code", c);

                        let r = await loadGameForCode(wedding_guid, c);
                        console.log(r);
                        games = r.data;
                        mode = "client";
                    }
                } catch (e) {
                    console.log(e);
                    await showError(translateError(e));
                }
            }
        }
    }

    async function stop() {
        try {
            stopItemTimer();
            stopItem();
            result = null;
            item = null;
            mode = null;
            await action(admin_code || code, game_id, "stop");
        } catch (e) {
            console.log(e);
            //await showError(translateError(e));
        }
    }

    async function start() {
        try {
            let r = await action(admin_code || code, game_id, "start");
            console.log(r);
            game = r.data;
            mode = "admin";
            game = r.data;
        } catch (e) {
            console.log(e);
            await showError(translateError(e));
        }
    }

    async function restart() {
        await stop();
        await start();
    }

    async function curr() {
        try {
            let r = await action(admin_code || code, game_id, "curr");
            console.log(r);
            joined_count = r.joined_count || 0;
            if (r.item.id != item.id) {
                item = r.item;
                startItem(item, r.item_status, r.item_ttl);
            }
        } catch (e) {
            console.log(e);
            await showError(translateError(e));
        }
    }

    async function prev() {
        // prev
        try {
            let r = await action(admin_code || code, game_id, "prev");
            console.log(r);
            result = null;
            item = r.item;
            startItem(item, r.item_status, r.item_ttl);
        } catch (e) {
            console.log(e);
            await showError(translateError(e));
        }
    }

    async function next() {
        // next
        try {
            let r = await action(admin_code || code, game_id, "next");
            console.log(r);
            result = null;
            item = r.item;
            startItem(item, r.item_status, r.item_ttl);
        } catch (e) {
            console.log(e);
            await showError(translateError(e));
        }
    }

    const submit = async () => {
        try {
            let c = "" + c1 + c2 + c3 + c4 + c5 + c6;
            mode = null;
            game = null;
            item = null;
            game_type = null;
            // request admin ?
            if (is_admin) {
                if (game_id) {
                    navigate(`#/champiz/${wedding_guid}?admin&game=${game_id}&admin_code=${c}`);
                } else {
                    navigate(`#/champiz/${wedding_guid}?admin&admin_code=${c}`);
                }
            } else {
                if (team && game_id) {
                    navigate(`#/champiz/${wedding_guid}?game=${game_id}&team=${team}&code=${c}`);
                } else if (game_id) {
                    navigate(`#/champiz/${wedding_guid}?game=${game_id}&code=${c}`);
                } else {
                    navigate(`#/champiz/${wedding_guid}?code=${c}`);
                }
            }
        } catch (e) {
            await showError(translateError(e));
        }
    };

    function validate(event) {
        switch (event.target.name) {
            case "c1":
            case "c2":
            case "c3":
            case "c4":
            case "c5":
            case "c6":
                if (
                    event.target.value === "" ||
                    event.target.value === null ||
                    event.target.value === undefined
                ) {
                    event.target.setCustomValidity("Un chiffre est requis.");
                } else {
                    event.target.setCustomValidity("");
                    focusNext(form);
                }
                break;
            default:
                break;
        }
    }

    const pushResponse = async (r) => {
        if (disabled) return;

        disabled = true;
        if (r == 'A') {
            choiceA = true;
        } else if (r == 'B') {
            choiceB = true;
        } else if (r == 'C') {
            choiceC = true;
        } else if (r == 'D') {
            choiceD = true;
        }
        console.log("push response", r);
        try {
            let res = await push(code, game_id, user_id, team_name, r);
            await showOK("Réponse envoyée");
            disabled = false;
            choiceA = false;
            choiceB = false;
            choiceC = false;
            choiceD = false;
        } catch (e) {
            console.log(e);
            if (e.message == "422 - 365 User not joined.") {
                // try to join
                try {
                    let res2 = await join(code, game_id, team_name, user_id);
                    console.log(res2);
                    user_id = res2.user;
                    game = res2.data;
                    mode = "client";

                    // then retry
                    await push(code, game_id, user_id, team_name, r);
                    await showOK("Réponse envoyée");
                    disabled = false;
                    choiceA = false;
                    choiceB = false;
                    choiceC = false;
                    choiceD = false;
                } catch (ex) {
                    await showError(translateError(ex));
                    disabled = false;
                    choiceA = false;
                choiceB = false;
                choiceC = false;
                choiceD = false;
                }
            } else {
                await showError(translateError(e));
                disabled = false;
                choiceA = false;
                choiceB = false;
                choiceC = false;
                choiceD = false;
            }
        }
    };

    function translateError(e) {
        let msg = e.message;

        if (e.message == "410 - 251 Item closed.") {
            msg = "La question est terminée";
        } else if (e.message == "404 - 97 Invalid code.") {
            msg = "Le jeu n'a pas encore commencé";
        } else if (e.message == "404 - 115 Game over.") {
            msg = "Le jeu est terminé";
        } else if (e.message == "404 - 110 Game not found.") {
            msg = "Jeu non trouvé - Code invalide";
        } else if (e.message == "422 - 281 Already answered.") {
            msg = "Vous avez déjà répondu à cette question.";
        } else if (e.message == "410 - 372 Item not started.") {
            msg = "La question n'a pas commencé";
        }

        return msg;
    }

    const minutesToSeconds = (minutes) => minutes * 60;
    const secondsToMinutes = (seconds) => Math.floor(seconds / 60);
    const padWithZeroes = (number) => number.toString().padStart(2, "0");

    let interval;
    let timeout;

    function formatTime(timeInSeconds) {
        const minutes = secondsToMinutes(timeInSeconds);
        const remainingSeconds = timeInSeconds % 60;
        return `${padWithZeroes(minutes)}:${padWithZeroes(remainingSeconds)}`;
    }

    function stopEarlyTimer() {
        stopItem();
        timeout = 0
    }

    function startTimer(item, status, ttl) {
        stopTimer();
        if (item && item.timeout > 0) {
            if (status == "CLOSED") {
                timeout = 0;
            } else {
                timeout = ttl || item.timeout;
                interval = setInterval(() => {
                    if (timeout === 0) {
                        stopTimer();
                    }
                    timeout -= 1;
                }, 1000);
            }
        }
    }

    function stopTimer() {
        if (interval) {
            clearInterval(interval);
        }
    }

    let globalWS;
    function startGlobalWS() {

        globalWS = new WebSocket(`${wsBase}`);
        globalWS.addEventListener("open", () => {
            console.log("WebSocket Global opened");
            globalWS.send(game_id + "_items_idx");
        });

        globalWS.addEventListener("message", (msg) => {
            console.log(msg);
            curr();
            // result = JSON.parse(msg.data);
            // TODO
        });

        globalWS.addEventListener("error", (msg) => {
            console.log("error", msg);
            stopGlobalWS();
        });

        globalWS.addEventListener("close", (msg) => {
            console.log("close", msg);
            stopGlobalWS();
        });

    }

    let itemTimer;
    function startItemTimer() {
        
        stopItemTimer();

        console.log("Starting item timer...")
        itemTimer =  setInterval(() => {
            curr();
        }, 2000);
    }

    function stopItemTimer() {
        if (itemTimer) {
            console.log("Stopping item timer");
            clearInterval(itemTimer);
        }
    }

    function stopGlobalWS() {
        if (globalWS != null) {
            globalWS.close();
            globalWS = null;
        }
    }

    function startItem(item, status, ttl) {
        console.log("startItem", item, status, ttl);
        stopItem();
        if (item && item.timeout) {
            if (status == "CLOSED") {
                timeout = 0;
            } else {
                timeout = ttl || item.timeout;
                interval = setInterval(() => {
                    if (timeout === 0) {
                        stopItem();
                    }
                    timeout -= 1;
                }, 1000);

                if (item.type === "Q" || item.type === "L") {
                    console.log("starting WebSocket", wsBase);
                    ws = new WebSocket(`${wsBase}`);
                    ws.addEventListener("open", () => {
                        console.log("WebSocket opened");
                        ws.send(game_id + "_" + item.id + "_res_" + item.order + "_0");
                    });

                    ws.addEventListener("message", (msg) => {
                        console.log(msg);
                        result = JSON.parse(msg.data);
                    });

                    ws.addEventListener("error", (msg) => {
                        console.log("error", msg);
                        stopItem();
                    });

                    ws.addEventListener("close", (msg) => {
                        console.log("close", msg);
                    });
                }
            }
        }
    }

    function stopItem() {
        if (interval) {
            clearInterval(interval);
        }

        if (ws != null) {
            ws.close();
            ws = null;
        }
    }

    function openGame(g) {
        console.log("opening game", g);
        games = null;
        mode = null;
        if (team) {
            navigate(`#/champiz/${wedding_guid}?game=${g.id}&team=${team}&code=${code}`);
        } else {
            navigate(`#/champiz/${wedding_guid}?game=${g.id}&code=${code}`);
        }
    }

    function isStarted(g) {
        let now = new Date();
        let start = fromSQLDate(g.start);
        if (!g.duration) {
            return now >= start;
        } else {
            let end = new Date();
            end.setTime(start.getTime() + parseInt(g.duration, 10) * 1000);

            //console.log(start, now, end);
            return now >= start && now <= end;
        }
    }

    function isStopped(g) {
        return g.state == "STOPPED";
    }

    function isRunning(g) {
        return g.state == "RUNNING";
    }

    function isReady(g) {
        return g.state == "NOT_STARTED";
    }

    function isEnded(g) {
        if (g.duration) {
            let now = new Date();
            let start = fromSQLDate(g.start);
            let end = new Date();
            end.setTime(start.getTime() + parseInt(g.duration, 10) * 1000);
            return now > end;
        }

        return false;
    }

    function home() {
        game = null;
        mode = null;
        if (team) {
            navigate(`#/champiz/${wedding_guid}?team=${team}&code=${code}`);
        } else {
            navigate(`#/champiz/${wedding_guid}?code=${code}`);
        }
    }


    onMount(async () => {
        console.log("Champiz on mount");
/*
        userRequest = getUser();

        try {
            let r = await $userRequest;
        } catch (e) {
            // annymous is ok
        }

    */
    });

    onDestroy(() => {
        if (ws) {
            console.log("on destroy closing WebSocket");
            ws.close();
        }
    });
</script>

<main>

        <HStack alignment="center" basis="60px">
            <img src="/images/champignon.svg" alt="champiz" width="48px" />
            {#if mode == "client" || mode == "master" }
                <Button action={home}>
                    <Label icon="undo-alt" text="retour" />
                </Button>
            {/if}
            <span class="title">Champiz</span>
            <Spacer />
            {#if mode == "admin" }
                <span class="" >Joueurs : <b>{joined_count}</b></span>
            {/if}
            <Spacer fixed minSpacing="48px" />
        </HStack>

    {#if !code && !admin_code}
        <form
            bind:this={form}
            class:error={showError}
            on:submit|preventDefault={submit}
            on:invalid={validate}
            on:changed={validate}
            on:input={validate}>
            <p>Entrez le code du jeu pour démarrer.</p>
            <Padding>
                <HStack justify="space-evenly" alignment="normal">
                    <Digit id={"c1"} focused bind:value={c1} bind:current />
                    <Digit id={"c2"} bind:value={c2} bind:current />
                    <Digit id={"c3"} bind:value={c3} bind:current />
                    <Digit id={"c4"} bind:value={c4} bind:current />
                    <Digit id={"c5"} bind:value={c5} bind:current />
                    <Digit id={"c6"} bind:value={c6} bind:current />
                </HStack>
            </Padding>
            <button class="primary" type="submit">Démarrer</button>
        </form>
    {:else if game_id}
        {#if game_type == "QCM"}
            {#if mode == "admin"}
                <div class="game">
                    <HStack grow alignment="stretch">
                        {#if item}
                            <HStack grow alignment="stretch">
                                <VStack grow>
                                    {#if item.type === "R" || item.type === "F"}
                                    <section class="lock">
                                        <TextView
                                            content={JSON.parse(
                                                item.content != "" ? item.content : "{}"
                                            )} />
                                    </section>
                                        {#if result}
                                            <TabList>
                                                {#each result as r, i}
                                                    <Tab bind:selected={selectedTab} tab={i}>
                                                        {`${i + 1}`}
                                                    </Tab>
                                                {/each}
                                                <Tab bind:selected={selectedTab} tab="global">
                                                    Classement Général
                                                </Tab>
                                            </TabList>
                                            {#each result as r, i}
                                                <TabPanel bind:selected={selectedTab} panel={i}>
                                                    <table>
                                                        <thead>
                                                            <th>Classement</th>
                                                            <th>Equipe/Joueur</th>
                                                            {#if is_details}
                                                                <th>Joueurs</th>
                                                                <th>% Réponses OK</th>
                                                                <th>Réponses OK</th>
                                                                <th>Rangs cumulés</th>
                                                                <th>Rangs</th>
                                                            {/if}
                                                            <th>Score</th>
                                                        </thead>
                                                        <tbody>
                                                            {#each r.result as r, idx}
                                                                {#if r.team != 0}
                                                                    <tr>
                                                                        <td width="50px">
                                                                            {#if idx == 0 && r.score > 0}
                                                                                <i
                                                                                    style="color: #C9B037;"
                                                                                    class="fas fa-trophy" />
                                                                            {:else if idx == 1 && r.score > 0}
                                                                                <i
                                                                                    style="color: #D7D7D7;"
                                                                                    class="fas fa-trophy" />
                                                                            {:else if idx == 2 && r.score > 0}
                                                                                <i
                                                                                    style="color: #6A3805;"
                                                                                    class="fas fa-trophy" />
                                                                            {/if}
                                                                            {idx + 1}
                                                                        </td>
                                                                        <td>{r.team}</td>
                                                                        {#if is_details}
                                                                            <td
                                                                                >{`${r.total} / ${r.minTotal}`}</td>
                                                                            <td
                                                                                >{`${r.pct}% / ${r.pctMin}%`}</td>
                                                                            <td
                                                                                >{`${r.count} / ${r.minCount}`}</td>
                                                                            <td>{r.rank}</td>
                                                                            <td>{r.ranks}</td>
                                                                        {/if}
                                                                        <td>{r.score}</td>
                                                                    </tr>
                                                                {/if}
                                                            {/each}
                                                        </tbody>
                                                    </table>
                                                </TabPanel>
                                            {/each}
                                            <TabPanel bind:selected={selectedTab} panel={"global"}>
                                                <table>
                                                    <thead>
                                                        <th>Classement</th>
                                                        <th>Equipe/Joueur</th>
                                                        <th>Score</th>
                                                        {#if is_details}
                                                            <th>Rangs cumulés</th>
                                                        {/if}
                                                    </thead>
                                                    <tbody>
                                                        {#each result_global as r, idx}
                                                            {#if r.team != 0}
                                                                <tr>
                                                                    <td width="50px">
                                                                        {#if idx == 0 && r.score > 0}
                                                                            <i
                                                                                style="color: #C9B037;"
                                                                                class="fas fa-trophy" />
                                                                        {:else if idx == 1 && r.score > 0}
                                                                            <i
                                                                                style="color: #D7D7D7;"
                                                                                class="fas fa-trophy" />
                                                                        {:else if idx == 2 && r.score > 0}
                                                                            <i
                                                                                style="color: #6A3805;"
                                                                                class="fas fa-trophy" />
                                                                        {/if}
                                                                        {idx + 1}
                                                                    </td>
                                                                    <td>{r.team}</td>
                                                                    <td>{r.score}</td>
                                                                    {#if is_details}
                                                                        <td>{r.rank}</td>
                                                                    {/if}
                                                                </tr>
                                                            {/if}
                                                        {/each}
                                                    </tbody>
                                                </table>
                                            </TabPanel>
                                        {/if}
                                    {:else}
                                        <section>
                                            <TextView
                                                content={JSON.parse(
                                                    item.content != "" ? item.content : "{}"
                                                )} />
                                        </section>
                                    {/if}
                                    <div class="actions">
                                        <HStack alignment="stretch">
                                            {#if item.id != game.items[0]}
                                                <Button action={prev}>
                                                    <Icon name="backward" size="48" />
                                                </Button>
                                                <Spacer />
                                                <Button action={restart}>
                                                    <Icon name="redo-alt" size="48" />
                                                </Button>
                                            {/if}
                                            <Spacer />
                                            {#if item.type === "Q" || item.type === "L"}
                                                <div class="timer">
                                                    {#if timeout > 0}
                                                        {formatTime(timeout)}
                                                        <Button action={ stopEarlyTimer }>
                                                            <Icon name="stop" size="48" />
                                                        </Button>
                                                    {:else}
                                                        Question terminée
                                                    {/if}
                                                </div>
                                            {/if}
                                            <Spacer />
                                            {#if item.id != game.items[game.items.length - 1]}
                                                <Button action={next}>
                                                    <Icon name="forward" size="48" />
                                                </Button>
                                            {:else}
                                                <Button action={stop}>
                                                    <Icon name="stop" size="48" />
                                                </Button>
                                            {/if}
                                        </HStack>
                                    </div>
                                </VStack>
                                {#if result && (item.type === "Q" || (item.type === "L" && timeout == 0))}
                                    <div class="result">
                                        <MediaQuery query="(max-height: 800px)">
                                            <Chart
                                                bind:this={chartRef}
                                                {data}
                                                type="bar"
                                                height="480"
                                                axisOptions={{ xAxisMode: "tick" }} />
                                        </MediaQuery>
                                        <MediaQuery query="(min-height: 801px)">
                                            <Chart
                                                bind:this={chartRef}
                                                {data}
                                                type="bar"
                                                height="600"
                                                axisOptions={{ xAxisMode: "tick" }} />
                                        </MediaQuery>
                                    </div>
                                {/if}
                            </HStack>
                        {/if}
                    </HStack>
                </div>
            {:else if mode == "client" || mode == "master"}
                <div ontouchstart="" style="display:flex; flex-grow: 1; max-height: 400px;">
                    <VStack grow>
                        <HStack>
                            <Spacer />
                            <article class:choiceA on:touchstart={() => pushResponse("A")}>
                                <span>A</span>
                            </article>
                            <Spacer />
                            <article class:choiceB on:touchstart={() => pushResponse("B")}>
                                <span>B</span>
                            </article>
                            <Spacer />
                        </HStack>
                        <Spacer />
                        <HStack>
                            <Spacer />
                            <article class:choiceC on:touchstart={() => pushResponse("C")}>
                                <span>C</span>
                            </article>
                            <Spacer />
                            <article class:choiceD on:touchstart={() => pushResponse("D")}>
                                <span>D</span>
                            </article>
                            <Spacer />
                        </HStack>
                        <Spacer />
                    </VStack>
                </div>
                {#if mode == "master"}
                    <div class="actions">
                        <HStack alignment="stretch">
                            <Button action={restart}>
                                <Icon name="redo-alt" size="48" />
                            </Button>
                            <Button action={stop}>
                                <Icon name="stop" size="48" />
                            </Button>
                            <Spacer />
                            <Button action={prev}>
                                <Icon name="backward" size="48" />
                            </Button>
                            <Spacer />
                            {#if item}
                                {#if item.type === "Q" || item.type === "L"}
                                    <div class="timer">
                                        {#if timeout > 0}
                                        <HStack>
                                            <span>{formatTime(timeout)}&nbsp;</span>
                                            <Spacer />
                                            <Button action={ stopEarlyTimer }>
                                                <Icon name="stop" size="48" />
                                            </Button>
                                        </HStack>
                                        {:else}
                                            Question terminée
                                        {/if}
                                    </div>
                                {/if}
                            {/if}
                            <Spacer />
                            <Button action={next}>
                                <Icon name="forward" size="48" />
                            </Button>
                        </HStack>
                    </div>
                {/if}
            {/if}
        {:else if game_type == "LOCK"}
            <h1>{game.name}</h1>
            {#if game.image}
                <span class="image">
                    <img src={game.image} alt="game" width="" height="" />
                </span>
            {/if}
            {#if item}
                <section class="lock">
                    <TextView content={JSON.parse(item.content != "" ? item.content : "{}")} />
                </section>
                {#if item.type == "Q" || item.type == "L"}
                    <div class="lock">
                        <Odometer bind:value={odo1} />
                        <Odometer bind:value={odo2} />
                        <Odometer bind:value={odo3} />
                        <Odometer bind:value={odo4} />
                    </div>
                {/if}
                {#if mode == "admin"}
                    <div class="actions">
                        <HStack alignment="stretch">
                            <Button action={prev}>
                                <Icon name="backward" size="48" />
                            </Button>
                            <Spacer />
                            <Button action={restart}>
                                <Icon name="redo-alt" size="48" />
                            </Button>
                            <Button action={stop}>
                                <Icon name="stop" size="48" />
                            </Button>
                            <Spacer />
                            {#if item.type == "Q" || item.type == "L"}
                                <div class="timer">
                                    {#if timeout > 0}
                                        {formatTime(timeout)}
                                    {:else}
                                        Question terminée
                                    {/if}
                                </div>
                            {/if}
                            <Spacer />
                            <Button action={next}>
                                <Icon name="forward" size="48" />
                            </Button>
                        </HStack>
                    </div>
                {:else}
                    {#if item.type == "Q" || item.type == "L"}
                        {#if timeout > 0}
                            <button
                                class:disabled
                                class="primary"
                                type="submit"
                                on:click={tryUnlock}>
                                <i class="fas fa-user-plus" />
                                <span>Ouvrir</span>
                            </button>
                            <Spacer />
                            <div class="timer">
                                {formatTime(timeout)}
                            </div>
                        {:else}
                            <div class="timer">Game over!</div>
                        {/if}
                    {:else}
                        <div class="timer">Jeu terminé</div>
                    {/if}
                {/if}
            {/if}
        {:else if game_type != null}
            <div class="error">Type de jeu non reconnu</div>
        {/if}
    {:else if games}
        <div class="games">
            {#each games as g (g.id)}
                {#if isRunning(g)}
                    <div on:click={openGame(g)} class="game-cell">
                        <img src={g.image} alt={g.name} height="48" />
                        <span class="name">{g.name}</span>
                        <span
                            class="started"
                            style="color: var(--primary-light-color); font-size: small;">
                            Démarré
                        </span>
                        <i class="fas fa-chevron-right started" />
                    </div>
                {:else if isStarted(g) && isReady(g)}
                    <div class="game-cell">
                        <img src={g.image} alt={g.name} height="48" />
                        <span class="name">{g.name}</span>
                        <span
                            class="started"
                            style="color: var(--primary-light-color); font-size: small;">
                            Prêt
                        </span>
                    </div>
                {:else if isEnded(g) || isStopped(g)}
                    <div class="game-cell">
                        <img src={g.image} alt={g.name} height="48" />
                        <span class="name">{g.name}</span>
                        <span style="color: var(--error-color);font-size: small;">Terminé</span>
                    </div>
                {:else}
                    <div class="game-cell">
                        <img src={g.image} alt={g.name} height="48" />
                        <span class="name">{g.name}</span>
                        <span style="color: var(--secondary-light-color); font-size: small;">
                            Début {moment(fromSQLDate(g.start)).fromNow()}</span>
                        <div class="disabled" />
                    </div>
                {/if}
            {/each}
        </div>
        
    {/if}

    {#if game_id && team && (mode == "client" || mode == "master")}
            <VStack alignment="center">
                {#if team_name === undefined}
                    <span class="team"></span>
                {:else if team_name !== null}
                    <HStack>
                        <span class="team">
                            {team_name}
                        </span>
                        <Button action={changeName}>
                            <Label icon="sync-alt" size="32" />
                        </Button>
                    </HStack>
                {:else}
                    <span class="team_error">
                        <i class="fas fa-exclamation-triangle" />Equipe invalide
                    </span>
                {/if}
            </VStack>
    {:else if wedding_name}
    <span class="wedding" style="display:none;">
        {wedding_name}
    </span>
    {/if}

</main>

<style>
    main {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        margin: 2em;
        min-height: 520px;
        text-align: center;
        user-select: none;
        -webkit-user-select: none;
    }

    span.title {
        text-align: center;
        font-family: Cinzel;
        font-size: 24px;
        font-weight: bold;
        margin-left: 0.5em;
    }
    span.team {
        font-size: 20px;
    }

    span.team_error {
        font-size: 20px;
        color: var(--error-color);
    }

    article {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        user-select: none;
        -webkit-user-select: none;
        height: 160px;
        width: 160px;
        font-size: xx-large;
        text-align: center;
        border: 1px solid;
        border-radius: 5px;
        cursor: pointer;
    }

    article:hover:not(.disabled) {
        color: var(--primary-light-color);
    }

    /*
    article.disabled {
        background-color: var(--primary-light-gray-color);
    }
    */

    article.choiceA {
        background-color: var(--secondary-light-color);
    }

    article.choiceB {
        background-color: var(--secondary-light-color);
    }
    article.choiceC {
        background-color: var(--secondary-light-color);
    }
    article.choiceD {
        background-color: var(--secondary-light-color);
    }

    form {
        max-width: 480px;
        margin: 1em auto;
        flex-grow: 1;
    }

    div.timer {
        border-radius: 15px;
        background-color: var(--secondary-light-color);
        color: var(--on-primary-color);
        padding: 0.5em;
        padding-left: 1em;
        padding-right: 1em;
        font-size: x-large;
        font-weight: bold;
        align-self: center;
    }

    div.result {
        height: 65vh;
        width: 400px;
        position: absolute;
        right: 10px;
        /*bottom: 150px;*/
        z-index: 1;
        max-height: 65vh;
    }

    div.actions {
        margin-bottom: 1em;
    }

    button {
        font-size: large;
        padding: 1em;
    }

    div.lock {
        /* position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%); */
        padding: 0;
        border-radius: 0.2em;
        z-index: 100;
        display: flex;
        font-size: 100px;
        align-self: center;
        margin: 0.25em;
    }

    section {
        display: flex;
        flex-direction: column;
        padding-top: 5px;
        margin-bottom: 5px;
        border-bottom: 1px solid var(--secondary-light-color);
        flex-grow: 1 !important;
        min-height: 720px;
        max-height: 920px;
        margin-left: 1em;
    }

    section.lock {
        min-height: unset !important;
    }

    /*
    div.game {
        margin-top: -1.5em;
    }
*/

    div.games {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        padding-top: 5px;
        margin-bottom: 5px;
        border-bottom: 1px solid var(--secondary-light-color);
        flex-grow: 1 !important;
    }

    div.game-cell {
        display: flex;
        height: 6em;
        border-bottom: 1px solid var(--secondary-light-color);
        /* background-color: var(--primary-dark-color);
        color: var(--on-primary-color); */
        justify-content: space-between;
        align-items: center;
    }

    div.game-cell:first-of-type {
        border-top: 1px solid var(--secondary-light-color);
    }

    div.game-cell i {
        line-height: 3em;
        margin-right: 5px;
    }

    div.game-cell span {
        margin-right: 5px;
    }

    div.game-cell span.name {
        flex-grow: 1;
    }

    .started {
        color: var(--primary-light-color);
        cursor: pointer;
    }

    h1 {
        color: var(--primary-color);
        margin: 0;
    }

    span.image img {
        width: 100%;
    }

    @media screen and (max-height: 800px) {
        div.lock {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            margin: unset;
        }
    }

    @media (max-width: 320px) {
        main {
            margin-left: 0.5em;
            margin-right: 0.5em;
        }
        article {
            height: 140px;
            width: 140px;
        }
        div.lock {
            font-size: 55px;
        }
        div.timer {
            font-size: inherit;
        }
        button {
            font-size: inherit;
        }
    }
    @media screen and (min-width: 320px) and (max-width: 360px) {
        main {
            margin-left: 0.5em;
            margin-right: 0.5em;
        }
        article {
            height: 160px;
            width: 160px;
        }
        div.lock {
            font-size: 65px;
        }
        div.timer {
            font-size: inherit;
        }
    }
    @media screen and (min-width: 360px) and (max-width: 375px) {
        main {
            margin-left: 0.5em;
            margin-right: 0.5em;
        }
        article {
            height: 160px;
            width: 160px;
        }
        div.lock {
            font-size: 72px;
        }
        div.timer {
            font-size: inherit;
        }
    }
    @media screen and (min-width: 376px) and (max-width: 414px) {
        main {
            margin-left: 0.5em;
            margin-right: 0.5em;
        }
        article {
            height: 160px;
            width: 160px;
        }
        div.lock {
            font-size: 80px;
        }
        div.timer {
            font-size: inherit;
        }
    }

    table {
        border-collapse: collapse;
        width: 100%;
        margin: 1em;
    }

    td {
        border: 1px solid #ddd;
        padding: 8px;
    }

    th {
        border: 1px solid #ddd;
        padding: 8px;
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: var(--primary-light-color);
        color: white;
    }

    tr:nth-child(even) {
        background-color: #f2f2f2;
    }
</style>
